import styled, { css } from 'styled-components';
import { iconColorMap } from './color-map';
import { iconSizeMap } from './size-map';
import type { IconColor, IconSize } from './type';

export const SvgIconWrapper = styled.span<{
  $size?: IconSize;
  $color?: IconColor;
}>`
  width: ${({ $size }) => ($size ? iconSizeMap[$size] : iconSizeMap.xs)};
  height: ${({ $size }) => ($size ? iconSizeMap[$size] : iconSizeMap.xs)};
  display: inline-block;
  vertical-align: middle;
  line-height: 0;

  ${({ $color }) =>
    $color &&
    css`
    color: ${iconColorMap[$color]};
  `};
  `;
